/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

//bestseller slider
$(document).ready(function () {
    $('.best-seller').owlCarousel({
      loop:false,
      autoplay: true,
      autoplayTimeout: 2000, 
      autoplayHoverPause: true,
      margin:10,
      dots:false,
      nav:true,
      touchDrag:true,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:2
          },
          1000:{
              items:1.9
          }
      }
  })

//limited edition slider
    $('.li_edition').owlCarousel({
      loop:true,
      autoplay: true,
      autoplayTimeout: 2000, 
      autoplayHoverPause: true,
      margin:10,
      dots:false,
      nav:true,
      touchDrag:true,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:2
          },
          1000:{
              items:1.9
          }
      }
  })
});




